import { mergeCartItems, toCartRequestItems } from "@horseed/shared/cart";
import { getCartKey } from "../utils/identifiers";
import { loadCartFromStorage, saveCartToStorage } from "../utils/storage";
import { addToCart } from "./cart.service";
export { mergeCartItems, toCartRequestItems };
export function claimDeviceCartStorageForUser(userId) {
  if (!userId) {
    return { mergedCart: [], deviceCart: [], userCart: [] };
  }
  const userKey = getCartKey(userId);
  const deviceKey = getCartKey(null);
  const userCart = loadCartFromStorage(userKey) || [];
  const deviceCart = loadCartFromStorage(deviceKey) || [];
  const mergedCart = mergeCartItems(userCart, deviceCart);
  saveCartToStorage(userKey, mergedCart);
  if (deviceCart.length > 0) {
    try {
      localStorage.removeItem(deviceKey);
    } catch (_) {
      /* ignore storage errors */
    }
  }
  return { mergedCart, deviceCart, userCart };
}
export async function claimDeviceCartForUser(userId) {
  const result = claimDeviceCartStorageForUser(userId);
  const requestItems = toCartRequestItems(result.deviceCart);
  if (requestItems.length > 0) {
    await addToCart(userId, requestItems);
  }
  return result;
}